<template src="./template.html" />

<script>
export default {
  name: 'PageMenu',
  props: {
    linksList: Array,
  },
}
</script>
